import { bindEvents, getRootOffset } from '../../../assets/js/helpers';

import ResizeController from '../../../assets/js/controller/resize';

const selector = 'hero-standard';

export default class HeroStandard {

	constructor(section) {
		this.el = {
			section,
			heading: section.querySelector('h1'),
			imageWrapper: section.querySelector(`.${selector}__image-container`),
			images: section.querySelectorAll(`.${selector}__image`),
			counters: section.querySelectorAll(`.${selector}__counter`),
			cta: section.querySelector(`.${selector}__cta`),
			textWrapper: section.querySelector(`.${selector}__text`)
		};

		// class variable groups

		this.bounds = {
			images: [],
			winWidth: 0,
			winHeight: 0
		};

		this.controllers = {
			resize: null
		};

		this.state = {
			index: 0
		};

		// class variables

		// bind events to class scope
		this.events = bindEvents(this);

		// mosey
		this.init();
	}

	static get selector() {
		return selector;
	}

	init() {
		this.measure();
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = ResizeController.set({
			update: () => { this.measure(); },
			resize: () => {}
		});
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);
	}

	// measurement calculations

	measure() {
		this.bounds.winWidth = window.innerWidth;
		this.bounds.winHeight = window.innerHeight;

		for (let i = 0; i < this.el.images.length; i++) {
			const img = this.el.images[i];
			const { top } = getRootOffset(img);
			const bottom = top + img.clientHeight;

			this.bounds.images[i] = {
				top,
				bottom
			};
		}

		const style = window.getComputedStyle(this.el.section);
		const imageHeight = this.el.imageWrapper.scrollHeight + parseInt(style.paddingTop) + parseInt(style.paddingBottom);

		this.el.section.style.minHeight = `${imageHeight}px`;
		this.el.textWrapper.style.minHeight = `${imageHeight}px`;
	}

	renderElements() {
		let html = '';

		for (let i = 0; i < 10; i++) {
			html += `<span>${i}</span>`;
		}

		for (const counter of this.el.counters) {
			counter.innerHTML = html;
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
